import { safeReadJsonFromLocalStorage } from "../../utils/storage";

export const TENANT_BOOTSTRAP_CACHE_KEY = "tenantBootstrapCache";
export const ACTIVE_TENANT_SLUG_KEY = "activeTenantSlug";

const TENANT_SCOPED_LOCAL_STORAGE_KEYS = [
  "activeShipData",
  "provisionedVesselId",
  "lastSyncTime",
  "lastSyncTimeIso",
  "activeCredentialPackageVersion",
  "currentUser",
  "users",
  "localLoginThrottle",
  "activeVoyageId",
  "selectedTripId",
  "selectedCargoId",
  "selectedCargoIndex",
  "selectedTripIndex",
  "lastVoyageSync",
];

export const readCachedTenantBootstraps = () =>
  safeReadJsonFromLocalStorage(TENANT_BOOTSTRAP_CACHE_KEY, {});

export const readCachedTenantBootstrap = (tenantSlug) =>
  readCachedTenantBootstraps()?.[tenantSlug] || null;

export const writeCachedTenantBootstrap = (tenantBootstrap) => {
  if (!tenantBootstrap?.tenantSlug) return;

  const cachedBootstraps = readCachedTenantBootstraps();
  cachedBootstraps[tenantBootstrap.tenantSlug] = tenantBootstrap;
  localStorage.setItem(
    TENANT_BOOTSTRAP_CACHE_KEY,
    JSON.stringify(cachedBootstraps)
  );
};

export const readActiveTenantSlug = () =>
  localStorage.getItem(ACTIVE_TENANT_SLUG_KEY);

export const writeActiveTenantSlug = (tenantSlug) => {
  if (!tenantSlug) {
    localStorage.removeItem(ACTIVE_TENANT_SLUG_KEY);
    return;
  }

  localStorage.setItem(ACTIVE_TENANT_SLUG_KEY, tenantSlug);
};

export const clearTenantScopedState = () => {
  TENANT_SCOPED_LOCAL_STORAGE_KEYS.forEach((key) => {
    localStorage.removeItem(key);
  });
};

export const hasProvisionedWorkspace = () =>
  Boolean(
    localStorage.getItem("provisionedVesselId") ||
      localStorage.getItem("activeShipData")
  );

